import { SquareProps } from "@chakra-ui/layout";
import { Circle } from "@chakra-ui/react";

type StatusDotType = "success" | "warning" | "error";

export interface StatusDotProps {
  type: StatusDotType;
}

const colorForType: Record<StatusDotType, SquareProps["color"]> = {
  success: "primary.400",
  warning: "warning.400",
  error: "error.400",
};

export const StatusDot: React.FC<StatusDotProps> = ({ type }) => (
  <Circle size="8px" bg={colorForType[type]} />
);
